import React from 'react';

class ContactCard extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { contact } = this.props;
    return (
      <div className="ContactCard">
        {(contact.street || contact.city) && (
          <address>
            {contact.street}
            {contact.street && contact.street2 && <br />}
            {contact.street2}
            {contact.street && contact.city && <br />}
            {contact.city}
          </address>
        )}
        {contact.phone && <tel>{contact.phone}</tel>}
        {contact.email && <a href={'mailto:' + contact.email}>{contact.email}</a>}
      </div>
    );
  }
};

export default ContactCard;



// WEBPACK FOOTER //
// ./client/Core/Components/ContactCard.jsx